import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import MallManager from "@/assets/manager.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
import Taxi from "@/assets/taxi.svg";
import UberCareem from "@/assets/uber.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

import Banks from "@/assets/project-assets/banks.svg";
import Electronics from "@/assets/project-assets/electronics.svg";
import FashionAccessories from "@/assets/project-assets/fashions-accessoiries.svg";
import FashionLadies from "@/assets/project-assets/fashionlandies.svg";
import FashionMen from "@/assets/project-assets/fashionmen.svg";
import FashionUnisex from "@/assets/project-assets/fashionunisex.svg";
import Optics from "@/assets/project-assets/optics.svg";
import Speciality from "@/assets/speciality-services.svg";
import SportsWear from "@/assets/project-assets/sportswear.svg";
import Pharmacies from "@/assets/project-assets/phamacies.svg";
import Desserts from "@/assets/confectionary.svg";
import Parking from "@/assets/project-assets/parking.svg";
import HomeTech from "@/assets/home&tech.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import GiftCard from "@/assets/gift_cards.svg";
import LingerieSwimwear from "@/assets/project-assets/swimwear.svg";
import Bus from "@/assets/project-assets/bus.svg";
import Handbags from "@/assets/handbags.svg";
import Telecom from "@/assets/telecom.svg";
import CafesRestaurants from "@/assets/cafes-restaurants.svg";
import SecurityOffice from "@/assets/security-office.svg";
import CivilRegistry from "@/assets/civil-registration.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "185.6,100%,41.8%",
    icon: FaBagShopping,
    items: [
      {
        title: "banks-financial",
        iconImage: Banks,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:ac8abe8f-21ee-4275-955c-4fee2d19a038",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-home-mobile",
        iconImage: Electronics,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:3a0349f7-60e2-467a-9219-da6f8d0e3681",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:b90c545b-b77c-4f61-a912-6b0dfc46b7a1",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Fashion,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:8cecb266-aca0-4968-acae-4dc9f63c2a3f",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:dda6a112-d557-4d28-af3f-9312895fb787",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:d17eee67-ffff-40ff-bf5a-edab3a958d68",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:b45a72d9-65aa-436a-b231-e3696cca029b",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "handbags-shoes",
        iconImage: Handbags,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:ee112921-2847-4e72-aabe-86fa3ec52ac5",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:df8a09b6-a914-45c1-ac1e-5d3d600e1851",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:4c4cc863-553f-4d00-a9d9-1a8b511d6ccf",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:aff077ca-1b45-4362-83a2-141df8b95882",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "lingerie-swimwear",
        iconImage: LingerieSwimwear,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:739d793e-4f5d-4a19-a903-650463483b4e",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: Optics,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:bdb0d007-25e1-4d64-862b-3c12f0681bcf",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pharmacy-health-fitness-cosmetics-perfumes",
        iconImage: Pharmacies,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:fc301636-4eb6-4701-939e-8c54dbcc92fa",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "services",
        iconImage: Speciality,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:98f54742-7d99-446d-ae6e-1b579f894a15",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsWear,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:c7148cb4-9fbb-4f8a-af8c-33a3c65b78bd",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "telecom-services",
        iconImage: Telecom,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:715c8562-1e50-4378-bc1d-885bdef555ee",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "10.6,100%,61.2%",
    icon: FaUtensils,
    items: [
      {
        title: "chocolates-confectionery-icecream",
        iconImage: Desserts,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:a564d9b7-81f1-4407-9043-5a430671b596",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "cafes-restaurants",
        iconImage: CafesRestaurants,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:30478330-0855-4ea9-b9ee-6542c56ba04a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:2ca54835-6913-4407-9575-5dea213166f2",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284.4,100%,38.4%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "be10bdce-cd82-4c67-8559-2e6b8e78d587:5ce8d16a-e795-4e2c-802c-083312db4d06",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "40.6,99%,61.4%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:2de3434a-27ec-40c1-a050-4e6e8c1083a2",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:532a2083-8c3e-44a2-b962-a6ac46188d30",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:90de4d7b-2266-4da7-89d1-72f0dfe012ea",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:4337e2a0-5f49-492c-9f5e-6a248dfeea77",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:2daf892e-f7a0-4e0f-86c2-5872c68fcfe0",
        type: "list",
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:f2a690da-8fd5-4f4f-9623-ffdb25977866",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:90de4d7b-2266-4da7-89d1-72f0dfe012ea",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:4337e2a0-5f49-492c-9f5e-6a248dfeea77",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:90de4d7b-2266-4da7-89d1-72f0dfe012ea",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:4337e2a0-5f49-492c-9f5e-6a248dfeea77",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "taxi-pickup",
        iconImage: Taxi,
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:640aad5d-72df-4e81-a4d3-d577283577c4",
        ],
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:7a6507a5-de6e-4a6d-8ff8-8b08cb12e36c",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:90340e56-26ac-4c34-9384-04ac7087c554",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:3b2c6475-ff3e-4969-8249-a70adf22f40c",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:5bc160e5-06e0-4a9c-b21f-d89c58d20eb7",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:da9b52c5-211e-41f9-aa40-176fc675bb08",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:da9b52c5-211e-41f9-aa40-176fc675bb08",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:da9b52c5-211e-41f9-aa40-176fc675bb08",
        type: "closest",
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideIconUntilSelected: true,
        hideMapIcon: false,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:f2a690da-8fd5-4f4f-9623-ffdb25977866",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:434ea14c-6801-445a-8e6c-72151942350d",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "security-office",
        iconImage: SecurityOffice,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:da9b52c5-211e-41f9-aa40-176fc675bb08",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "civil-registry",
        iconImage: CivilRegistry,
        id: "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:cfbdab1e-da6a-4567-9e10-a5b17b9623c1",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-bays",
        id: [],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vacant",
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:8cc1f7af-5f62-4cfa-9c61-f2abcebc86b5",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:b2e8a72e-753c-4bd3-8d0c-c518ee72bdbb",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "parking",
        iconImage: Parking,
        id: [],
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [
          "2b4a9a5e-35b6-4b80-ba96-084c6aff64f0:4d28565c-1519-49e1-96bb-1b1bfea588e0",
        ],
        type: "list",
        listed: false,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
